import { render, staticRenderFns } from "./HistoricoLancesApagados.vue?vue&type=template&id=0ae72531&"
import script from "./HistoricoLancesApagados.vue?vue&type=script&lang=js&"
export * from "./HistoricoLancesApagados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports